// Tiny shared HTML → plain-text helper. Used everywhere brief_content
// (or any other Quill-style HTML field) needs to render as a card
// preview, version-diff column, or comment-mention snippet.
//
// Steps:
//   1. Strip every <tag> attribute and tag itself.
//   2. Collapse &nbsp; into spaces (Quill emits these for empty lines).
//   3. Round-trip the remaining text through a <textarea> so the
//      browser decodes every other entity the spec knows about —
//      &apos;, &amp;, &quot;, &lt;, &gt;, &#39;, &mdash;, etc. Before
//      this, the supplier-portal card preview surfaced raw entity
//      codes ("Don&apos;t" instead of "Don't") because we only knew
//      to decode &nbsp; explicitly.
//   4. Collapse any whitespace runs that remain after decoding so a
//      paragraph break and a literal newline both render as one space.

export const htmlToPlainText = (html) => {
  if (!html) return '';
  const s = String(html);
  const stripped = s.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ');
  if (typeof document === 'undefined') {
    // SSR / Node — skip the textarea trick and return the partially
    // decoded string. The browser path is the one that actually runs
    // in our app; this branch keeps the helper test-importable.
    return stripped.replace(/\s+/g, ' ').trim();
  }
  const ta = document.createElement('textarea');
  ta.innerHTML = stripped;
  return ta.value.replace(/\s+/g, ' ').trim();
};
